import {reloadLayer} from '../base/AbstractMapActions';

export {reloadLayer};

export const SET_TOPIC = 'mapio.setTopic';
export const SET_BACKGROUND_LAYER = 'mapio.setBackgroundLayer';
export const SET_FOREGROUND_LAYER = 'mapio.setForegroundLayer';
export const SET_LAYERS = 'mapio.setLayers';
export const SET_CATALOG_NODES = 'mapio.setCatalogNodes';
export const SET_LOCATION = 'mapio.setLocation';
export const SET_ZOOM = 'mapio.setZoom';
export const SET_FILTER = 'mapio.setFilter';

/**
 * Nastaví téma konfigurace.
 *
 * @param {string} area - oblast store
 * @param {string} topic - téma konfigurace
 * @returns {Object} akce
 */
export function setTopic(area, topic) {
    return {type: SET_TOPIC, area, topic};
}

/**
 * Nastaví podkladovou vrstvu.
 *
 * @param {string} area - oblast store
 * @param {string} layerId - ID vrstvy
 * @returns {Object} akce
 */
export function setBackgroundLayer(area, layerId) {
    return {type: SET_BACKGROUND_LAYER, area, layerId};
}

/**
 * Nastaví popisnou vrstvu.
 *
 * @param {string} area - oblast store
 * @param {?string} layerId - ID vrstvy nebo null
 * @returns {Object} akce
 */
export function setForegroundLayer(area, layerId) {
    return {type: SET_FOREGROUND_LAYER, area, layerId};
}

/**
 * Nastaví viditelné datové vrstvy.
 *
 * @param {string} area - oblast store
 * @param {Array<string>} layerIds - pole ID vrstev
 * @returns {Object} akce
 */
export function setLayers(area, layerIds) {
    return {type: SET_LAYERS, area, layerIds};
}

/**
 * Nastaví rozbalené uzly katalogu.
 *
 * @param {string} area - oblast store
 * @param {Array<string>} nodeIds - pole ID uzlů katalogu
 * @returns {Object} akce
 */
export function setCatalogNodes(area, nodeIds) {
    return {type: SET_CATALOG_NODES, area, nodeIds};
}

/**
 * Nastaví pozici středu mapy.
 *
 * @param {string} area - oblast store
 * @param {Array<number>} location - pole 2 souřadnic [longitude, latitude]
 * @returns {Object} akce
 */
export function setLocation(area, location) {
    return {type: SET_LOCATION, area, location};
}

/**
 * Nastaví zoom mapy.
 *
 * @param {string} area - oblast store
 * @param {zoom} zoom - hodnota zoomu
 * @returns {Object} akce
 */
export function setZoom(area, zoom) {
    return {type: SET_ZOOM, area, zoom};
}

/**
 * Nastaví filtr pro features v datových vrstvách.
 *
 * @param {string} area - oblast store
 * @param {Object} filter - filtr
 * @param {Date|string} [filter.date] - specifické datum, nebo symbolická datumová konstanta
 * @param {Date} [filter.dateFrom] - počáteční datum (včetně)
 * @param {Date} [filter.dateTo] - koncové datum (včetně)
 * @returns {Object} akce
 */
export function setFilter(area, filter) {
    return {type: SET_FILTER, area, filter};
}
